Pixlee.module('SlideShowApp.Show', function(Show, App, Backbone, Marionette, $) {
    var size;

    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            frame: '.slideshow_frame'
        },
        ui: {
            slideshow_widget: '#slideshow_widget'
        },
        initialize: function() {
            var _this = this;
            var resize = function(size) {
                _this.ui.slideshow_widget.css('height', size);
                _this.ui.slideshow_widget.css('width', size);
                _this.ui.slideshow_widget.css('opacity', 1);
            };

            var receiveMessage = function(event) {
                try {
                    var eventData = JSON.parse(event.data);

                    if (eventData.name === 'pixlee:resize:widget') {
                        var height = eventData.data.height;
                        var width = eventData.data.width;
                        if (width > height) {
                            size = Math.floor(height);
                        } else {
                            size = Math.floor(width);
                        }

                        resize(size);
                    }
                } catch (e) {
                    // console.log('invalid json');
                    return;
                }

            };

            window.addEventListener('message', receiveMessage, false);
        },
        onShow: function() {
            this.ui.slideshow_widget.css('opacity', 1);
            window.addEventListener('resize', this.sendMessage);
        },
        sendMessage: function() {
            var message = {
                name: 'pixlee:widget:shape',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    type: 'square'
                }
            };
            window.parent.postMessage(JSON.stringify(message), '*');
        },
        templateHelpers: function() {
            return {
                widgetDesc: App.altText
            };
        }
    });
    Show.Layout.include(['AccessibilityHelpers']);

    Show.PhotoView = App.Views.ItemView.extend({
        template: require('./templates/photo_item.jst.ejs'),
        className: 'photo_block',
        tagName: 'li',
        initialize: function() {
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
        },
        onShow: function() {
            this.$el.css('height', size);
            this.$el.css('width', size);
            this.$el.css('opacity', 1);
        },
        templateHelpers: function() {
            var _this = this;
            var currentUser = App.currentUser.toJSON();
            var config = App.config.toJSON();
            return _.extend({
                ariaRole: 'img',
                campaign: function() {
                    return _this.options.campaign;
                },
                currentUser: currentUser,
                config: config,
                decode_utf8: function(s) {
                    return App.request('decode:utf8', s);
                }
            }, App.request('concern', 'PhotoHelpers'));
        }
    });
    Show.PhotoViewLightbox = App.Views.ItemView.extend({
        template: require('./templates/photo_item.jst.ejs'),
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Lightbox: {}
        },
        initialize: function() {
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
        },
        onShow: function() {
            this.$el.css('height', size);
            this.$el.css('width', size);
            this.$el.css('opacity', 1);
        },
        templateHelpers: function() {
            var _this = this;
            var currentUser = App.currentUser.toJSON();
            var config = App.config.toJSON();
            return _.extend({
                ariaRole: 'button',
                campaign: function() {
                    return _this.options.campaign;
                },
                currentUser: currentUser,
                config: config,
                decode_utf8: function(s) {
                    return App.request('decode:utf8', s);
                }
            }, App.request('concern', 'PhotoHelpers'));
        }
    });
    // Slideshow View
    Show.SlideShowCollection = App.Views.CollectionView.extend({
        className: 'clearfix',
        tagName: 'ul',
        behaviors: {
            CollectionVote: {},
            RefreshOnCssGenerated: {},
            HideEmptyAlbumWidget: {}
        },
        events: {
            'keydown': 'onKeydown',
            'click': 'onClick',
            'focusout': 'startSlideshow',
            'focusin': 'onFocusin',
        },
        initialize: function() {
            // initially false but toggled on when they focus using
            // keyboard controls
            this.keyboardControl = false;
        },
        onKeydown: function(e) {
            var keycode = e.keyCode;
            if (keycode === 37 || keycode === 39) {
                // left or right arrow, go to the next slide
                keycode === 37 ? this.sly.prev() : this.sly.next();
                this.stopSlideshow();
                this.arrowNavigation = true;
                this.keyboardControl = true;
            } else if (keycode === 9) {
                // tab or shift tab
                if (this.arrowNavigation) {
                    // if we just arrow navigated, focus on current photo
                    e.preventDefault();
                    var newPhoto = this.$el.find('.photo_block.active').children().get(0);
                    newPhoto.focus();
                    this.arrowNavigation = false;
                }
                // else, default behaviour
                this.keyboardControl = true;
            }
        },
        onFocusin: function() {
            if (!this.keyboardControl) {
                var newPhoto = this.$el.find('.photo_block.active').children().get(0);
                newPhoto.focus();
            }
            this.stopSlideshow();
        },
        onClick: function() {
            // back to mouse control
            this.startSlideshow();
            this.keyboardControl = false;
        },
        getChildView: function() {
            if (this.options.showLightbox) {
                return Show.PhotoViewLightbox;
            } else {
                return Show.PhotoView;
            }
        },
        checkVideo: function() {
            var _this = this;
            this.resetVideo();
            if (this.$el.find('.photo_block.active').find('video').length > 0) {
                this.$el.find('.photo_block.active').find('video').css('height', size);
                this.$el.find('.photo_block.active').find('video').css('width', size);
                this.$el.find('.photo_block.active').find('video').attr('id', 'current_video');
                this.stopSlideshow();
                videojs('current_video', _this.videoOpts, function() {
                    // disable sound on ALL videos in the widget
                    if (gon.display_options.muteVideos) {
                        this.volume(0);
                    }
                    // Disable sound on single videos in the widget
                    if (gon.display_options.videoOptions && !gon.display_options.videoOptions.sound) {
                        this.muted(true); // mute to start
                    }
                    _this.videoPlayer = this;
                    _this.playerReady();
                });
                if (_this.videoPlayer) {
                    this.videoPlayer.off('ended');
                    _this.playerReady();
                }
            }

        },
        playerReady: function() {
            var _this = this;
            this.videoPlayer.player_.play();
            this.videoPlayer.on('ended', function() {
                _this.resetVideo();
            });
        },
        resetVideo: function() {
            var _this = this;
            var video = this.$el.find('#current_video');
            if (video.length > 0) {
                this.videoPlayer.player_.pause();
                this.videoPlayer.player_.currentTime(0);
                video.removeAttr('id');
                var vid = video[0];
                if (vid && vid['player']) {
                    delete vid['player'];
                }
            }
            if (this.sly) {
                this.sly.resume();
            }
        },
        startSlideshow: function() {
            if (!_.isFalsy(this.sly)) {
                this.sly.resume();
            }
        },
        stopSlideshow: function() {
            if (!_.isFalsy(this.sly)) {
                this.sly.pause();
            }
        },
        resizeWidget: function() {
            var _this = this;

            function receiveMessage(event) {
                try {
                    var eventData = JSON.parse(event.data);
                    var resize = function(size) {
                        _this.$el.find('.photo_block').css('height', size);
                        _this.$el.find('.photo_block').css('width', size);
                        _this.$el.find('.photo_block').css('opacity', 1);

                        if (_this.$el.find('.vjs-tech').length > 0) {
                            _this.$el.find('.vjs-tech').css('height', size);
                            _this.$el.find('.vjs-tech').css('width', size);
                        }
                    };
                    if (eventData.name === 'pixlee:resize:widget') {
                        var height = eventData.data.height;
                        var width = eventData.data.width;
                        if (width > height) {
                            size = Math.floor(height);
                        } else {
                            size = Math.floor(width);
                        }

                        resize(size);
                    }
                } catch (e) {
                    // console.log('invalid json');
                    return;
                }


            }

            window.addEventListener('message', receiveMessage, false);
        },
        onRender: function() {
            var _this = this;
            _this.videoOpts = {
                flash: {
                    swf: '/flash/video-js.swf'
                },
                techOrder: ['html5', 'flash']
            };
            if (this.collection.length > 0) {
                var slideshowFrame = $('.slideshow_frame');
                var options = {
                    horizontal: 1,
                    itemNav: 'centered',
                    smart: 1,
                    mouseDragging: 0,
                    touchDragging: 1,
                    releaseSwing: 1,
                    startAt: 0,
                    scrollBy: 0,
                    speed: 1000,
                    elasticBounds: 1,
                    easing: 'swing',
                    prev: $('.prev'),
                    next: $('.next')
                };
                if (!_.isFalsy(App.displayOptions.get('widget_autoplay_showHide'))) {
                    options.cycleBy = 'items';
                    options.cycleInterval = App.displayOptions.get('widget_lightbox_interval') || 3000;
                }
                this.sly = new Sly(slideshowFrame, options, {
                    'change': function() {
                        var isFetching = _this.collection.next;
                        var isEnd = false;
                        var position = $(this)[0].pos;
                        _this.checkVideo();
                        if (position.dest / position.end > 0.6 && isFetching) {
                            _this.collection.nextPage({
                                success: function() {
                                    var photo_block = $('#slideshow_widget .slideshow_frame ul .photo_block');
                                    var video = $('#slideshow_widget .slideshow_frame ul .photo_block .vjs-tech');

                                    photo_block.css('opacity', '1');
                                    photo_block.css('height', size);
                                    photo_block.css('width', size);

                                    if (video.length > 0) {
                                        video.css('height', size);
                                        video.css('width', size);
                                    }


                                    _this.sly.reload({
                                        silentScroll: true
                                    });

                                }
                            });
                        }

                    },
                    'moveEnd': function() {
                        // if we move with arrow keys or tabs, stop slideshow
                        if (_this.keyboardControl) {
                            _this.stopSlideshow();
                        }
                    }
                }).init();
                _this.checkVideo();
                _this.resizeWidget();
            }
        }
    });
    Show.SlideShowCollection.include(['tabindexHelpers', 'socialShareHelpers']);
});
